import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as globals from '@reusable/services/globals';
import { ToastrService } from 'ngx-toastr';
import { EMPTY } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable()
export class ProfileCustomerService {
  responseData: any;
  handleError: any;

  constructor(private router: Router, private httpClient: HttpClient, private gtn: globals.GetTokenNow, private toastr: ToastrService) {}
  userProfile() {
    return this.httpClient.get(`${globals.domain}/customer/profile/view`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  userEditProfile() {
    return this.httpClient.get(`${globals.domain}/customer/profile/edit/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  userUpdateProfile(userData) {
    return this.httpClient.put(`${globals.domain}/customer/profile/update/`, JSON.stringify(userData), this.gtn.getHeaders())
      .pipe(map(res => {
        if ((res as any).case === 2) {
          this.toastr.warning('هذا الإيميل موجود من قبل مستخدم اخر، أدخل إيميل أخر.');
          return EMPTY;
        }
        return res as any;
      }));
  }

  userUpdateEmail(email) {
    return this.httpClient
      .put(`${globals.domain}/customer/profile/update-email/`, JSON.stringify({ email }), this.gtn.getHeaders())
      .pipe(map(res => {
        if ((res as any).case === 2) {
          this.toastr.warning('هذا الإيميل موجود من قبل مستخدم اخر، أدخل إيميل أخر.');
          return EMPTY;
        }
        return res as any;
      }));
  }

  listAreas(sort, records, pageNumber, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/areas/list/sortBy-${sort}/${records}/${null}?isDeleted=${queries}`, headers)
      .pipe(map(res => res as any));
  }
  listCites(sort, records, pageNumber, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/cities/list/sortBy-${sort}/${records}/${pageNumber}/`, headers)
      .pipe(map(res => res as any));
  }
  listDistricts(sort, records, pageNumber, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/core/districts/list/sortBy-${sort}/${records}/${pageNumber}/`, headers)
      .pipe(map(res => res as any));
  }
  listAddresses(queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient.get(`${globals.domain}/customer/addresses/list/`, headers).pipe(map(res => res as any));
  }
  createAddress(body) {
    return this.httpClient.post(`${globals.domain}/customer/addresses/create`, body, this.gtn.getHeaders()).pipe(map(res => res as any));
  }

  updateMarketingPrefrences(body) {
    return this.httpClient.put(`${globals.domain}/customer/profile/update-notifications-preferences/`, body, this.gtn.getHeaders()).pipe(map(res => res as any));
  }

  closeAccount() {
    return this.httpClient.delete(`${globals.domain}/customer/profile/delete-my-account/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }

  viewAddress(addressId) {
    return this.httpClient.get(`${globals.domain}/customer/addresses/${addressId}/view/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  updateAddress(addressId, body) {
    return this.httpClient.put(`${globals.domain}/customer/addresses/${addressId}/update/`, body, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  deleteAddress(addressId) {
    return this.httpClient.delete(`${globals.domain}/customer/addresses/${addressId}/remove/`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }
  listWalletTransactions(sort, records, pageNumber, queries?) {
    const headers = this.gtn.getHeaders();
    headers['params'] = queries;
    return this.httpClient
      .get(`${globals.domain}/customer/wallets-transactions/list/sortBy-${sort}/${records}/${pageNumber}/`, headers)
      .pipe(map(res => res as any));
  }
}